import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=57f5daeb&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f5daeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f5daeb')) {
      api.createRecord('57f5daeb', component.options)
    } else {
      api.reload('57f5daeb', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=57f5daeb&scoped=true&", function () {
      api.rerender('57f5daeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/settings/Notification.vue"
export default component.exports